import ReactDOM from 'react-dom/client';
import './index.css';
import "./i18n";
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from './Redux/Store';
// import { LoadScript } from '@react-google-maps/api';
const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));
// const GOOGLE_MAPS_API_KEY = "AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o";
root.render(
    <>
    {/* <LoadScript 
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      libraries={['places']}           // ← very important for Autocomplete
    > */}
        <Provider store={store }>
            <ToastContainer />
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </Provider>
        {/* </LoadScript> */}
    </>
);
